import { request } from "../core/request";
import { OPERATION_IDS } from "./constants";
import type { IMapMyIndiaRequest, IMapMyIndiaResponse } from "../types/mapMyIndiaTypes";

const MMI_CONNECTION_FROM = "Upgrade-ws";
const MMI_SOURCE = "3in1web";

export const mapMyIndia = async (payload: IMapMyIndiaRequest): Promise<IMapMyIndiaResponse> => {
  return request<IMapMyIndiaResponse, IMapMyIndiaRequest>({
    operationId: OPERATION_IDS.mmi,
    requestData: payload,
    connectionFrom: MMI_CONNECTION_FROM,
    additionalHeaders: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Connection-from": MMI_CONNECTION_FROM,
      source: MMI_SOURCE,
    },
  });
};
